import * as siteTypes from './list'

import { SiteType } from 'app/types/park/site'

export const allSiteTypes: SiteType[] = Object.values(siteTypes).sort(
    (previous, current) => previous.priority - current.priority,
)
